// Ledger Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get ledger list from backend then update ledgerList in vuex store ***** //
export const updateLedgerList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc',
      date: payload.date,
      outlet_id: payload.outlet_id
    }
  }

  try {
    const result = await Axios.get(`report_general_ledger`, {
      params: params
    })
    commit('updateLedgerList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Get ledger detail list from backend then update ledgerDetailList in vuex store ***** //
export const updateLedgerDetailList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc',
      date: payload.date,
      outlet_id: payload.outlet_id
    }
  }

  try {
    const result = await Axios.get(`ledger_account_detail/${payload.id}`, {
      params: params
    })
    commit('updateLedgerDetailList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
